import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import { Box, Link, Typography } from 'web-library';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import FormHeader from '../../../../components/form-items/FormHeader';
import { AppealOutcomeSummary } from '../../../../api/candidate/appeal/model';
import DocumentBadge from '../../../../components/DocumentBadge';
import { useGetAppealOutcome } from '../../../../api-refactored/appeal/useGetAppealOutcome';

interface AppealOutcomeProp {
  appealOutcome: AppealOutcomeSummary;
}

const AppealOutcome = ({ appealOutcome }: AppealOutcomeProp) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { refetch: getAppealOutcome } = useGetAppealOutcome({
    fileKey: (appealOutcome && appealOutcome.fileKey) || '',
    onSuccess: (res) => {
      const newWindow = window.open(res.url, '_blank', 'noopener,noreferrer');
      if (newWindow) {
        newWindow.opener = null;
      }
    },
  });

  return (
    <Box marginBottom={theme.spacing(1)}>
      <FormHeader title={t('appeal->>AppealSummary.AppealOutcome.Header')} />

      {appealOutcome ? (
        <Box display="grid" gridTemplateColumns="repeat(2, 1fr)">
          <DocumentBadge documentName={appealOutcome.fileName} />
          <Link id="link-download" onClick={() => getAppealOutcome()}>
            <IconWithLabel
              iconName={IconName.download}
              iconSize="M"
              label={t('appeal->>AppealSummary.AppealOutcome.Download')}
              typographyProps={{
                variant: 'h5',
              }}
            />
          </Link>
        </Box>
      ) : (
        <Typography>-</Typography>
      )}
    </Box>
  );
};

export default AppealOutcome;
